import { render, staticRenderFns } from "./CreateOrEditBuyerPurchase.vue?vue&type=template&id=0f0fcc67&scoped=true&"
import script from "./CreateOrEditBuyerPurchase.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditBuyerPurchase.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditBuyerPurchase.vue?vue&type=style&index=0&id=0f0fcc67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0fcc67",
  null
  
)

export default component.exports